export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8ca2c8ae8e14c04473c48b00e15d0bc4.jpg"
          alt="背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
              <span className="w-2 h-2 bg-pink-400 rounded-full animate-pulse"></span>
              <span className="text-sm text-white font-medium">新人オーディション開催中</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
              輝く<span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400">才能</span>を
              <br />
              世界へ届ける
            </h1>
            <p className="text-lg text-gray-200 mb-8 leading-relaxed max-w-lg">
              STELLAR LIVEは、次世代のVTuberタレントを発掘・育成するプロダクションです。あなたの夢を叶えるステージがここにあります。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={() => scrollToSection('contact')}
                className="px-8 py-4 bg-gradient-to-r from-pink-500 to-cyan-500 text-white text-sm font-bold rounded-full hover:opacity-90 transition-all inline-flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
              >
                <span>オーディションに応募する</span>
                <i className="ri-arrow-right-up-line text-lg"></i>
              </button>
              <button
                onClick={() => scrollToSection('talents')}
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-sm font-bold rounded-full hover:bg-white/20 transition-all inline-flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer border border-white/30"
              >
                <span>タレントを見る</span>
                <i className="ri-play-fill text-lg"></i>
              </button>
            </div>
          </div>

          <div className="relative flex justify-center">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-pink-500/30 to-cyan-500/30 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Adorable%20fluffy%20furry%20creature%20character%20with%20extremely%20soft%20and%20thick%20fur%20covering%20entire%20body%20in%20vibrant%20pink%20and%20cyan%20gradient%20colors%2C%20cute%20big%20sparkling%20eyes%2C%20pink%20fur%20on%20one%20side%20blending%20into%20cyan%20blue%20fur%20on%20other%20side%2C%20cheerful%20friendly%20expression%2C%20kawaii%20anime%20style%2C%20professional%20character%20illustration%20with%20clean%20simple%20background%2C%20high%20quality%20digital%20art%2C%20mascot%20design%20with%20neon%20pink%20and%20cyan%20color%20scheme&width=600&height=800&seq=vtuber-hero-fluffy-pink-cyan-002&orientation=portrait"
                alt="VTuberイメージ"
                className="relative w-full max-w-md h-auto rounded-3xl shadow-2xl object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('talents')}
          className="w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full cursor-pointer hover:bg-white/30 transition-colors"
        >
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </button>
      </div>
    </section>
  );
}